import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useContext, useState, useEffect } from 'react'

import AppRoutes from './pages/AppRoutes'
import { loadingContext, validContext } from './lib'
import { viewShield } from './lib/security/viewShield'

import SplashScreen from './pages/SplashScreen'
import Login from './pages/Login'
import Page404 from './pages/Page404'
import ModalVw, { ModalContent, ModalHeader, ModalBody, ModalFooter } from './components/common/ModalVw'

window.oncontextmenu = function () {

};
document.addEventListener("keypress", function (event) {
  var key = event.key;
  if (key === 'F12') {
    return false;
  }
}, false);

document.addEventListener("keyup", function (event) {
  var key = event.key;
  if (key === 'F12') {
    return false;
  }
}, false);

document.addEventListener("keydown", function (event) {
  var key = event.key;
  if (key === 'F12') {
    return false;
  }
}, false);




document.addEventListener("contextmenu", function (e) {

});

const originalGetItem = Storage.prototype.getItem;
const originalSetItem = Storage.prototype.setItem;
const originalRemoveItem = Storage.prototype.removeItem;
const originalClear = Storage.prototype.clear;
const realLocalStorage = window.localStorage;
const realSessionStorage = window.sessionStorage;

const notifySecurity = (method) => {
  console.warn(`[SECURITY] ${method} Access blocked by audit policy.`);
  return null;
};

// 2. FILTROS DE SEGURIDAD
const isAuthKey = (key) => /msal|login|authority|client|token|state|nonce|interaction|telemetry|request|response|error/i.test(key) ||
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}/i.test(key);
const isAppKey = (key) => /hashuser|hashinfo|hashselectedproject|selectedlanguage/i.test(key);

// 3. GENERADOR DE MOCKS (Crea un envoltorio único para cada storage)
const createMock = (realStorage, name) => ({
  getItem: function (key) {
    if (isAuthKey(key) || isAppKey(key)) {
      return originalGetItem.call(realStorage, key);
    }
    return notifySecurity(`${name}.getItem(${key})`);
  },
  setItem: function (key, value) {
    if (isAuthKey(key) || isAppKey(key)) {
      return originalSetItem.call(realStorage, key, value);
    }
    return notifySecurity(`${name}.setItem`);
  },
  removeItem: function (key) {
    if (isAuthKey(key) || isAppKey(key)) {
      return originalRemoveItem.call(realStorage, key);
    }
    return notifySecurity(`${name}.removeItem`);
  },
  clear: function () {
    if (window.location.hash.includes('code=') || window.location.hash.includes('state=')) {
      console.warn(`[SECURITY] ${name}.clear() blocked during redirect.`);
      return;
    }
    return originalClear.call(realStorage);
  },
  key: (i) => realStorage.key(i),
  get length() { return realStorage.length; }
});

/*const mockLocal = createMock(realLocalStorage, 'localStorage');
const mockSession = createMock(realSessionStorage, 'sessionStorage');

try {
  Object.defineProperty(window, 'localStorage', { get: () => mockLocal, configurable: true });
  Object.defineProperty(window, 'sessionStorage', { get: () => mockSession, configurable: true });

  Storage.prototype.getItem = function (key) {
    return (this === realSessionStorage || this === mockSession)
      ? mockSession.getItem(key)
      : mockLocal.getItem(key);
  };
} catch (e) {
  console.info("Seguridad de almacenamiento activa.");
}*/

function App() {
  const [loading] = useContext(loadingContext)
  const [isValid, setIsValid, , , , isAuthChecked] = useContext(validContext)

  const [showSessionModal, setShowSessionModal] = useState(false)
  const [countdown, setCountdown] = useState(10)

  var checkStatus;
  var indicator = document.querySelector('#devtool-status');

  // LISTA BLANCA DE HOSTS: Content-Security-Policy
  // Agregar hosts después de 'self' 
  useEffect(() => {



    // 2. Interceptación de Inyección en el DOM (Anula cajas de PoC)
    /*const orgNodeAppend = Node.prototype.appendChild;
    Node.prototype.appendChild = function (node) {
      if (node instanceof HTMLElement && /sessionStorage|localStorage|PoC/i.test(node.innerText || node.textContent || '')) {
        console.error("[SECURITY] Blocked data trail injection into the DOM.");
        return node;
      }
      return orgNodeAppend.call(this, node);
    };*/

    // 3. Bloqueo de creación de elementos sensibles
    /*const orgCreateElement = document.createElement.bind(document);
    document.createElement = (tag) => {
      const tagName = tag.toLowerCase();
      if (tagName === 'script' || tagName === 'iframe') {
        return orgCreateElement(tag);
      }
      return orgCreateElement(tag);
    };*/

    // Definir constantes para URLs permitidas
    const factoryUrl = process.env.REACT_APP_IVA_FACTORY_ULR || '';
    const chatbotUrl = process.env.REACT_APP_IVA_FACTORY_CHATBOT_URL || '';
    const dashboardUrl = process.env.REACT_APP_DASHBOARD || '';
    const azureUrl = process.env.REACT_APP_AZURE_ENDPOINT || '';
    const audioUrl = process.env.REACT_APP_AUDIOS || '';
    const msft = "https://login.microsoftonline.com";

    // Meta etiqueta de Content-Security-Policy
    const meta = document.createElement('meta');
    meta.httpEquiv = "Content-Security-Policy";

    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const ttPolicy = isLocal ? "trusted-types default webpack-dev-server#overlay;" : "trusted-types default;";

    meta.content = [
      "default-src 'self';",
      "script-src 'self' 'unsafe-inline' 'unsafe-eval' blob:;",
      `connect-src 'self' ${msft} ${factoryUrl} ${chatbotUrl} ${dashboardUrl} ${azureUrl} https://*.tts.speech.microsoft.com http://localhost:8080;`,
      `frame-src 'self' ${msft} ${dashboardUrl};`,
      "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com;",
      `media-src 'self' https://*.s3.amazonaws.com ${audioUrl} blob:;`,
      "font-src 'self' https://fonts.gstatic.com;",
      "img-src 'self' data: blob:;",
      "worker-src 'self' blob:;",
      "require-trusted-types-for 'script';",
      ttPolicy
    ].join(' ');

    document.getElementsByTagName('head')[0].appendChild(meta);

    const permMeta = document.createElement('meta');
    permMeta.httpEquiv = "Permissions-Policy";
    permMeta.content = "ambient-light-sensor=(), camera=(), microphone=(), geolocation=()";
    document.getElementsByTagName('head')[0].appendChild(permMeta);

  }, []);

  useEffect(() => {

    const handleExpired = () => {

      window.localStorage.removeItem('hashUser');
      window.localStorage.removeItem('hashInfo');
      window.sessionStorage.clear();

      setIsValid(false);

      setShowSessionModal(true);

      let time = 10;
      setCountdown(time);

      const interval = setInterval(() => {
        time -= 1;
        setCountdown(time);

        if (time <= 0) {
          clearInterval(interval);
          window.location.href = '/';
        }
      }, 1000);
    };

    window.addEventListener('session-expired', handleExpired);

    const handleStorageChange = (e) => {
      if (e.key === 'hashUser' && e.newValue === null) {
        handleExpired();
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('session-expired', handleExpired);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [setIsValid]);

  return (
    <>
      {loading && <SplashScreen />}
      <BrowserRouter>
        {!isAuthChecked ? (
          // Mientras se valida la sesión inicial no renderizamos rutas
          // para evitar que <Navigate to="/"> pise la URL actual
          // (p.ej. al refrescar estando en /:name/Settings).
          <SplashScreen />
        ) : (
          <Routes>
            {isValid && <Route path="/*" element={<AppRoutes />} />}
            {!isValid && <Route path="/" element={<Login />} />}
            {!isValid && <Route path="*" element={<Navigate to="/" replace />} />}
          </Routes>
        )}
      </BrowserRouter>

      {showSessionModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 999999
        }}>
          <ModalVw visible={true} style={{ width: '100%', maxWidth: '400px' }}>
            <ModalContent styles={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>
              <ModalHeader title="Session Expired" />
              <ModalBody>
                <p>Your session has expired. Redirecting in <strong>{countdown}</strong> seconds...</p>
              </ModalBody>
              <ModalFooter>
                <button
                  style={{
                    padding: '10px 20px',
                    cursor: 'pointer',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px'
                  }}
                  onClick={() => {
                    window.localStorage.clear();
                    window.sessionStorage.clear();
                    window.location.href = '/';
                  }}
                >
                  Log In Again
                </button>
              </ModalFooter>
            </ModalContent>
          </ModalVw>
        </div>
      )}

    </>
  )
}

export default App
